<template>
  <div>
    <h5 class="modal-title" id="authModalLabel">Регистрация</h5>

    <form @submit.prevent="register" class="my-4" v-if="!isRegisetred">
      <div class="mb-3">
        <label for="username" class="form-label">Фамилия и имя</label>
        <input
          type="text"
          class="form-control"
          id="username"
          v-model="form.full_name"
          required
        />
      </div>
      <div class="mb-3">
        <label for="email" class="form-label">E-mail</label>
        <input
          type="text"
          class="form-control"
          id="email"
          v-model="form.email"
          required
        />
        <div class="error" role="alert" v-if="emailError">
          {{ emailError }}
        </div>
      </div>
      <div class="mb-3">
        <label for="password" class="form-label">Пароль</label>
        <div class="password-field">
          <input
            :type="showPassword ? 'text' : 'password'"
            class="form-control"
            id="password"
            v-model="form.password"
            @input="checkPassword"
            required
          />
          <button
            type="button"
            class="eye-btn"
            @click="toggleShowPassword"
            aria-label="Показать/скрыть пароль"
          >
            <img
              src="@/assets/images/icons/eye-open.svg"
              class="eye_open"
              alt="Eye open"
              v-if="!showPassword"
            />
            <img
              src="@/assets/images/icons/eye-slashed.svg"
              class="eye_slashed"
              alt="Eye slashed"
              v-else
            />
          </button>
        </div>
        <div class="error" role="alert" v-if="passwordError">
          {{ passwordError }}
        </div>
      </div>
      <div class="mb-3">
        <label for="repeat-password" class="form-label">Повторить пароль</label>
        <div class="password-field">
          <input
            :type="showRepeatPassword ? 'text' : 'password'"
            class="form-control"
            id="repeat-password"
            v-model="repeatPassword"
            @input="checkRepeatPassword"
            required
          />
          <button
            type="button"
            class="eye-btn"
            @click="toggleShowRepeatPassword"
            aria-label="Показать/скрыть пароль"
          >
            <img
              src="@/assets/images/icons/eye-open.svg"
              class="eye_open"
              alt="Eye open"
              v-if="!showRepeatPassword"
            />
            <img
              src="@/assets/images/icons/eye-slashed.svg"
              class="eye_slashed"
              alt="Eye slashed"
              v-else
            />
          </button>
        </div>
        <div class="error" role="alert" v-if="repeatError">
          {{ repeatError }}
        </div>
      </div>
      <!-- <div class="error" role="alert">{{ error }}</div> -->
      <div class="my-3 form-check">
        <input
          type="checkbox"
          class="form-check-input"
          id="acceptTerms"
          v-model="form.acceptTerms"
          required
        />
        <label
          class="form-check-label"
          for="acceptTerms"
          style="font-size: 15px"
        >
          Я принимаю <a href="#">условия сервиса</a> и согласен на обработку
          <a href="#">персональных данных.</a>
        </label>
      </div>

      <button
        type="submit"
        class="btn btn-primary w-100"
        :disabled="!isFormValid"
      >
        <template v-if="!isLoading">Зарегистрироваться</template>
        <div v-else class="loader mx-auto my-0"></div>
      </button>
    </form>
    <template v-else>
      <p>Вы успешно зарегистрировались</p>
    </template>
    <div class="divider"></div>
    <!-- </form> -->
    <p class="mt-3 mb-1">У вас уже есть аккаунт?</p>
    <button type="button" class="btn btn-link" @click="switchView('AuthView')">
      Войти
    </button>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import AuthService from "../services/auth";

export default {
  name: "RegisterView",
  setup(props, { emit }) {
    const isLoading = ref(false);
    const username = ref("");
    // const error = ref(null);
    const email = ref("");
    const password = ref("");
    const isRegisetred = ref("");
    const repeatPassword = ref("");
    const showPassword = ref(false);
    const showRepeatPassword = ref(false);
    const repeatError = ref(null);
    const emailError = ref(null);
    const passwordError = ref(null);
    const form = ref({
      full_name: "",
      email: "",
      password: "",
      acceptTerms: "",
    });

    const toggleShowRepeatPassword = () => {
      showRepeatPassword.value = !showRepeatPassword.value;
    };

    const toggleShowPassword = () => {
      showPassword.value = !showPassword.value;
    };

    const checkRepeatPassword = () => {
      if (form.value.password !== repeatPassword.value) {
        repeatError.value = "Пароли не совпадают";
      } else {
        repeatError.value = null;
      }
    };

    const register = () => {
      isLoading.value = true;

      emailError.value = null;
      passwordError.value = null;

      if (!form.value.acceptTerms) {
        alert("Пожалуйста, примите условия.");
        return;
      }
      const data = {
        full_name: form.value.full_name,
        email: form.value.email,
        password: form.value.password,
      };
      AuthService.registration(data)
        .then((response) => {
          isRegisetred.value = true;
          isLoading.value = false;

          return Promise.resolve(response);
        })
        .catch((error) => {
          console.log("error", error);
          isLoading.value = false;
          if (error.response && error.response.data.email) {
            if (
              error.response.data.email[0] ===
              "Пользователь with this Электронная почта already exists."
            ) {
              emailError.value =
                "Пользватель с такой почтой уже зарегистрирован";
              return;
            }
          }
          if (error.response && error.response.data.password) {
            if (
              error.response.data.password[0] ===
              "The password is too similar to the Электронная почта."
            ) {
              passwordError.value = "Пароль слишком похож на электронную почту";
              return;
            }
          }
          // error.value = "Введите верные данные";
          // return Promise.reject(error);
        });
    };

    const switchView = (view) => {
      emit("switchView", view);
    };

    // Проверка валидности формы
    const isFormValid = computed(() => {
      return (
        form.value.full_name &&
        form.value.email &&
        form.value.password &&
        form.value.password.length >= 8 &&
        form.value.acceptTerms &&
        repeatPassword.value &&
        form.value.password === repeatPassword.value &&
        !repeatError.value
      );
    });

    const checkPassword = () => {
      passwordError.value = null;

      const minLength = /.{8,}/; // Проверка на минимальную длину (8+ символов)
      const hasDigit = /[0-9]/; // Проверка на наличие хотя бы одной цифры
      const hasSpecialChar = /[!@#$%^&*()_+<>?-]/; // Проверка на наличие специального символа

      if (!minLength.test(form.value.password)) {
        passwordError.value = "Пароль должен содержать минимум 8 символов.";
      } else if (!hasDigit.test(form.value.password)) {
        passwordError.value = "Пароль должен содержать хотя бы одну цифру.";
      } else if (!hasSpecialChar.test(form.value.password)) {
        passwordError.value =
          "Пароль должен содержать хотя бы один специальный символ.";
      } else {
        passwordError.value = null;
      }

      if (repeatPassword.value) checkRepeatPassword();
    };

    return {
      isRegisetred,
      form,
      username,
      email,
      password,
      isFormValid,
      // error,
      isLoading,
      register,
      switchView,
      checkPassword,
      repeatPassword,
      showPassword,
      showRepeatPassword,
      repeatError,
      toggleShowRepeatPassword,
      toggleShowPassword,
      checkRepeatPassword,
      emailError,
      passwordError,
    };
  },
};
</script>

<style scoped lang="scss">
.password-field {
  position: relative;
}

.eye-btn {
  position: absolute;
  top: 50%;
  left: 220px;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  // padding: 0;
  cursor: pointer;
  display: inline-flex;
  // align-items: center;
  justify-content: center;

  svg {
    width: 18px;
    height: 18px;
  }
}
</style>
